/**
*****************************************
*										*
* NAGARRO  - CSX - CONFIDENTIAL         *
*										*
*****************************************
*/



import * as _ from 'lodash';

import { Injectable, OnDestroy } from '@angular/core';

import { Alert } from '../model/alert.model';
import { AlertData } from '../model/alert-data.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config.service';
import { DataStoreService } from '../../../core/services/datastore.service';
import { HttpStatus } from '../../../core/model/http-status-enum.model';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { MessageDetails } from '../../../core/model/message-details.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { Tab } from '../../../core/model/tab.model';
import { TabData } from '../../../core/model/tab-data.model';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { UserProfile } from '../../../core/model/user-profile.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class AlertServiceService implements OnDestroy {

  private RESOURCE_URL = '/alerts';
  private configData: any;
  private apiUrl: string;
  alerts: Observable<AlertData>;
  alertsBS: BehaviorSubject<AlertData>;
  newAlerts: AlertData;
  startTimeMS: any;
  alertInterval: any;
  remainingTime: any;
  alertIntervalValue = 900000;
  lLastAccessTime = 0;

  constructor(private http: HttpClient,
    private configService: ConfigService,
    private dataStoreService: DataStoreService,
    private lmsLoggerService: LmsLoggerService,
    private router: Router,
    private lmsModuleService: LmsModuleService,
    private lmsLoaderService: LmsLoaderService,
    private messageHandlerService: MessageHandlerService,
    private appUtilityService: AppUtilityService,
    private staticDataStoreService: StaticDataStoreService) {
    this.configData = this.configService.getConfigData();
    this.apiUrl = this.configData.urls.API_URL;
    this.alertsBS = <BehaviorSubject<AlertData>>new BehaviorSubject({});
    this.alerts = this.alertsBS.asObservable();
  }

  init(tab: Tab) {
    const userProfile = <UserProfile>this.staticDataStoreService.getValue('userProfile');
    if (userProfile) {
      if (userProfile.alertType !== 'NON') {
        this.fetchData(tab);
        this.startTimer(tab);
      }
    } else {
      setTimeout(() => {
        this.init(tab);
      }, 400);
    }
  }

  startTimer(tab: Tab) {
    this.alertInterval = setInterval(() => {
      this.fetchData(tab);
    }, this.alertIntervalValue);
  }

  fetchData(tab: Tab) {
    this.startTimeMS = (new Date()).getTime();
    tab.subTypeDetail.data.status = 'refresh';
    this.load(tab, true);
  }

  pauseTimer() {
    clearInterval(this.alertInterval);
    this.remainingTime = this.alertIntervalValue - ((new Date()).getTime() - this.startTimeMS);
    this.alertInterval = null;
  }

  resumeTimer(tab: Tab) {
    setTimeout(() => {
      this.init(tab);
    }, this.remainingTime);
  }

  load(tab: Tab, isTimerCall: boolean, requestData?: any, message?: string) {
    if (!requestData) {
      const userPref = <UserProfile>this.staticDataStoreService.getValue('userProfile');
      requestData = {
        dirUser: (userPref.alertType && userPref.alertType === 'SYS') ? 'Y' : 'N',
        deskUser: (userPref.alertType && userPref.alertType === 'DES') ? 'Y' : 'N',
        desk: userPref.alertDesk ? userPref.alertDesk : ' '
      };
      if (userPref && userPref.alertType === 'SYS') {
        requestData.desk = ' ';
      }
    }
    let alerts: AlertData;
    if (tab && this.dataStoreService.getValue(tab) && !isTimerCall && tab.subTypeDetail.data.status !== 'refresh') {
      const data = this.dataStoreService.getValue(tab);
      alerts = <AlertData>(data.data.Alerts);
      this.alertsBS.next(alerts);
      this.lmsLoggerService.logInfo('AlertDataService => load()',
        `Alerts Data Fetch Successfull for ${JSON.stringify(tab)}`);
    } else if (tab && tab.subTypeDetail.data.status === 'refresh') {
      this.processRefreshServiceCall(requestData, tab, isTimerCall, message);
    } else {
      if (!isTimerCall) {
        this.lmsLoaderService.hideLoader();
      }
      this.alertsBS.next(null);
    }
  }

  /**
   * this is the helper method of load method
   * @private
   * @param {*} requestData
   * @param {Tab} tab
   * @param {boolean} isTimerCall
   * @param {string} [message]
   * @memberof AlertServiceService
   */
  private processRefreshServiceCall(requestData: any, tab: Tab, isTimerCall: boolean, message?: string) {
    if (!isTimerCall) {
      this.pauseTimer();
      this.lmsLoaderService.showLoader();
    }
    const opr = 'INQU';
    this.lmsLoggerService.logInfo('AlertServiceService=>load service call starts');
    this.http.get(
      `${this.configData.urls.API_URL}${this.RESOURCE_URL}?opr=${opr}&deskUser=${requestData.deskUser}&dirUser=${requestData.dirUser}&desk=${requestData.desk}`)
      .subscribe(data => {
        this.subscribeData(data, tab, isTimerCall, message);
      },
      error => {
        const lAlertData = <AlertData>({
          httpStatus: error.status,
          errorMessage: (!isTimerCall && message) ? message + ', but an error has occurred while refreshing the page.'
            : this.appUtilityService.getHttpErroMessage(error, false)
        });
        this.alertsBS.next(lAlertData);
        this.lmsLoggerService.logError('AlertDataService => load()', this.appUtilityService.getHttpErroMessage(error, false));
        if (!isTimerCall) {
          tab.subTypeDetail.data.message = lAlertData.errorMessage;
          this.lmsModuleService.updateSelectedTab(tab);
          this.startTimer(tab);
          this.lmsLoaderService.hideLoader();
        }
      });
  }

  /**
   * this is the helper method of load method
   * @private
   * @param {*} data
   * @param {*} tab
   * @param {boolean} isTimerCall
   * @param {string} [message]
   * @memberof AlertServiceService
   */
  private subscribeData(data: any, tab: any, isTimerCall: boolean, message?: string) {
    if (this.lLastAccessTime > 0) {
      this.lLastAccessTime = 0;
    }
    if (data && data.priorityCode) {
      const pCode = parseInt(data.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        // if (isTimerCall) {
        //   this.appUtilityService.hideAlertCount = false;
        // }
        let tabData: TabData;
        const lAlertData: AlertData = { alerts: [], lastAccessedTime: '' };
        const alertsArr = (data.alerts);
        tabData = <TabData>({
          id: tab.id,
          subType: tab.subType
        });
        lAlertData.alerts = alertsArr;

        tabData.data = tabData.data ? tabData.data : {};
        tabData.data[tab.subType] = lAlertData;

        lAlertData.lastRefreshTime = data.refreshTime;
        lAlertData.httpStatus = HttpStatus.OK;
        lAlertData.lastAccessedTime = data.lastAccessedTime;
        tab.subTypeDetail.data.message = '';
        tab.subTypeDetail.data.status = 'loaded';
        tab.tabSearchParameter = <TabSearchParameter>({ searchText: '' });
        tab.tabSearchParameter.searchText = 'alert window';
        this.dataStoreService.putValue(tab, tabData);
        this.alertsBS.next(<AlertData>tabData.data[tab.subType]);
        this.lmsLoggerService.logInfo('AlertDataService => load()',
          `Alerts Data Fetch Successfull for ${JSON.stringify(tab)}`);
        if (!isTimerCall && message) {
          this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configData.message.type.client,
            level: this.configData.message.level.success,
            target: this.configData.message.target.page,
            message: message
          }));
        }
      } else {
        const lAlertData = <AlertData>({
          httpStatus: 400,
          errorMessage: (!isTimerCall && message) ? message + ', but ' + data.messageText : data.messageText
        });
        this.alertsBS.next(lAlertData);
        if (!isTimerCall) {
          tab.subTypeDetail.data.message = lAlertData.errorMessage;
          this.lmsModuleService.updateSelectedTab(tab);
        }
        this.lmsLoggerService.logError('AlertDataService => load()', data.messageText);
      }
      if (!isTimerCall) {
        this.lmsLoaderService.hideLoader();
      }
    }
    if (!isTimerCall) {
      this.startTimer(tab);
    }
    this.lmsLoggerService.logInfo('AlertServiceService=>load service call ends');
  }

  updateAlertsAfterRead(alerts: AlertData) {
    this.alertsBS.next(alerts);
  }

  /**
   * this method is used to make a service call
   * when user submit the signoff status of selected alerts
   * @param {*} alerts
   * @param {*} requestData
   * @returns {Observable<Response>}
   * @memberof AlertServiceService
   */
  submitSignedOff(alerts: any, requestData: any): Observable<Response> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('AlertServiceService=>submitSignedOff service call starts');
    return this.http.put<Response>(`${this.configData.urls.API_URL}${this.RESOURCE_URL}?deskUser=${requestData.deskUser}&dirUser=${requestData.dirUser}&desk=${requestData.desk}`,
      JSON.stringify(alerts), options).pipe(
        tap(() => { this.lmsLoggerService.logInfo('AlertServiceService=>submitSignedOff service call ends') })
      );
  }

  ngOnDestroy() {
    this.alerts = null;
  }

  cleanBehaviourSubject() {
  }

  /**
   * Alert Update Service
   * @param {Alert} alert
   * @returns {Observable<any>}
   * @memberof AlertServiceService
   */
  alertReadUpdate(alert: Alert): Observable<any> {
    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers, responseType: 'blob' };
    return this.http.get(`${apiUrl}${this.RESOURCE_URL}/updateAlert?id=${alert.id}&cd=${alert.updateCreationTS}`, {
      headers: headers, responseType: 'blob'
    });
  }

  /**
   * Update Last Alert Screen Visit
   * @returns {Observable<any>}
   * @memberof AlertServiceService
   */
  updateLastUpdateAlert(): Observable<any> {
    let headers = new HttpHeaders();
    const userPref = <UserProfile>this.staticDataStoreService.getValue('userProfile');
    const requestData = {
      dirUser: (userPref.alertType && userPref.alertType === 'SYS') ? 'Y' : 'N',
      deskUser: (userPref.alertType && userPref.alertType === 'DES') ? 'Y' : 'N',
      desk: userPref.alertDesk ? userPref.alertDesk : ' '
    };
    if (userPref && userPref.alertType === 'SYS') {
      requestData.desk = ' ';
    }
    const apiUrl = this.configData.urls.API_URL;
    headers = headers.append('Content-Type', 'application/json');
    return this.http.get(`${apiUrl}${this.RESOURCE_URL}/lastVisitedAlert?lat=${this.lLastAccessTime}&desk=${requestData.desk}&deskUser=${requestData.deskUser}`, {
      headers, responseType: 'blob'
    });
  }

}
